import(/* webpackMode: "eager" */ "/home/runner/work/bs-website-2022/bs-website-2022/apps/web/src/app/[locale]/error.tsx");
